import React from 'react';
import { Helmet } from 'react-helmet';
import { isUserFromCountry } from '../utils/ipinfo';
import { organization } from '../utils/jsonld';

const siteMetadata =  {
  title: 'Uptime Monitoring',
  description: 'Beautifully simple and reliable uptime monitoring',
  author: '@sinequanonh',
}

const getImage = (image) => {
  if (!image || image.length === 0) return 'https://s3.eu-central-1.amazonaws.com/cdn.hyperping/ogimage.png';
  if (image.startsWith('http')) return image;
  return `https://hyperping.com${image}`;
}

function SEO({ description, lang, meta, keywords, title, image, showChatApp = true, jsonLd }) {
  const [showDrift, setShowDrift] = React.useState(false);
  
  React.useEffect(() => {
    if (!showChatApp) return setShowDrift(false);
    const allowedCountries = ['FR', 'NL', 'US', 'IN', 'DE'];
    isUserFromCountry(allowedCountries, (isAllowed) => {
      if (isAllowed) setShowDrift(true);
    });
  }, []);

  const metaDescription = description || siteMetadata.description;
  return (<>
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      meta={[
        {
          name: 'description',
          content: metaDescription,
        },
        {
          name: 'google-site-verification',
          content: 'NbuccHGky4VTZQWDxtsYADQeEhMXFx71GtknxW7musM',
        },
        {
          name: 'ahrefs-site-verification',
          content: '5657de2532cbb3b492dc8d965e0b53dc12e056f3b30cdb4d3d102258cdea057e',
        },
        {
          property: 'og:title',
          content: title,
        },
        {
          property: 'og:description',
          content: metaDescription,
        },
        {
          property: 'og:type',
          content: 'website',
        },
        {
          name: 'twitter:card',
          content: 'summary',
        },
        {
          name: 'twitter:creator',
          content: siteMetadata.author,
        },
        {
          name: 'twitter:title',
          content: title,
        },
        {
          name: 'twitter:description',
          content: metaDescription,
        },
        {
          name: 'og:image',
          content: getImage(image)
        },
        {
          name: 'og:twitter',
          content: getImage(image)
        }
      ]
        .concat(
          keywords.length > 0
            ? {
                name: 'keywords',
                content: keywords.join(', '),
              }
            : []
        )
        .concat(meta)}
    />
      <Helmet>
        {/* <script>
          {`!function(e,t,n,s,u,a){e.twq||(s=e.twq=function(){s.exe?s.exe.apply(s,arguments):s.queue.push(arguments);
          },s.version='1.1',s.queue=[],u=t.createElement(n),u.async=!0,u.src='//static.ads-twitter.com/uwt.js',
          a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(u,a))}(window,document,'script');
          twq('init','o15g2');
          twq('track','PageView');`}
        </script> */}
      </Helmet>
      
      {/* <Helmet>
        <script type="text/javascript">
          {`(function(c,l,a,r,i,t,y){
            c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
            t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
            y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
          })(window, document, "clarity", "script", "6fg9yma4xl");`}
        </script>
      </Helmet> */}

      {showDrift && <Helmet>
        <script>
          {`"use strict";

          !function() {
            var t = window.driftt = window.drift = window.driftt || [];
            if (!t.init) {
              if (t.invoked) return void (window.console && console.error && console.error("Drift snippet included twice."));
              t.invoked = !0, t.methods = [ "identify", "config", "track", "reset", "debug", "show", "ping", "page", "hide", "off", "on" ], 
              t.factory = function(e) {
                return function() {
                  var n = Array.prototype.slice.call(arguments);
                  return n.unshift(e), t.push(n), t;
                };
              }, t.methods.forEach(function(e) {
                t[e] = t.factory(e);
              }), t.load = function(t) {
                var e = 3e5, n = Math.ceil(new Date() / e) * e, o = document.createElement("script");
                o.type = "text/javascript", o.async = !0, o.crossorigin = "anonymous", o.src = "https://js.driftt.com/include/" + n + "/" + t + ".js";
                var i = document.getElementsByTagName("script")[0];
                i.parentNode.insertBefore(o, i);
              };
            }
          }();
          drift.SNIPPET_VERSION = '0.3.1';
          drift.load('icppntt97f2w');`}
        </script>
      </Helmet>}

      <Helmet>
        <script defer data-domain="hyperping.com" src="https://plausible.io/js/script.tagged-events.js"></script>
      </Helmet>
      
      <Helmet>
      {/* <script>
        var head = document.head || document.getElementsByTagName("head")[0];
        var script = document.createElement("script");
        script.setAttribute("src", "http://localhost:5775/stats.js"); // REPLACE WITH ACTUAL URL
        script.setAttribute("onload", () => window.collectStats());
        script.setAttribute("type", "text/javascript");
        script.setAttribute("charset", "utf8");
        script.setAttribute("async", "");
        head.appendChild(script);
      </script> */}
      </Helmet>
      {/* <Helmet>
      <script defer type="text/javascript" src="https://api.pirsch.io/pirsch.js"
        id="pirschjs"
        data-code="FKxnSkNdhrHCzdIfFkdgmZyU4cEF18aT"></script>
      </Helmet> */}

      {/* <Helmet>
        <script src="http://code.jquery.com/jquery-latest.min.js" type="text/javascript"></script>
      </Helmet> */}
      <Helmet>
        <script type="application/ld+json">{JSON.stringify({ '@context': 'https://schema.org', ...organization })}</script>
      </Helmet>
      {jsonLd && (
        <Helmet>
          <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
        </Helmet>
      )}
    </>
  )
}

SEO.defaultProps = {
  lang: 'en',
  meta: [],
  keywords: [],
}

export default SEO
